/** Resolve outcome exits using the same origin-relative HTTP(S) policy as CTA links. */
export function getSafeOutcomeUrl(url: string | undefined): string | undefined {
  if (!url) return undefined;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : undefined;
  } catch {
    return undefined;
  }
}

export function getOutcomeExitTarget(): '_top' | '_self' {
  return window.top !== window ? '_top' : '_self';
}

/** Only the destination is messaged; quiz answers and prospect data are never included. */
export function navigateOutcomeExit(url: string | undefined): 'navigated' | 'requested' | 'blocked' {
  const safeUrl = getSafeOutcomeUrl(url);
  if (!safeUrl) return 'blocked';
  const embedded = getOutcomeExitTarget() === '_top';
  try {
    if (embedded) {
      window.top!.location.href = safeUrl;
    } else {
      window.location.href = safeUrl;
    }
    return 'navigated';
  } catch {
    if (embedded) {
      try {
        // The host must authenticate the sender and allowlist the destination.
        window.parent.postMessage({ type: 'cla-quiz-navigate', url: safeUrl }, '*');
        return 'requested';
      } catch {
        // Sandboxed hosts may also reject messaging; do not navigate the iframe instead.
      }
    }
    return 'blocked';
  }
}